import { render, staticRenderFns } from "./OverflowChips.vue?vue&type=template&id=577a1216"
import script from "./OverflowChips.vue?vue&type=script&lang=js"
export * from "./OverflowChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports